<template>
  <div :style="marketDetails">
    <table
      v-if="market"
      class="market"
    >
      <tr class="market-row">
        <td
          v-if="silkImageUrl"
          class="silk"
        >
          <img
            :src="silkImageUrl"
            alt=""
          >
        </td>

        <td class="number">
          {{ market.num }}
        </td>

        <td class="runner">
          <div
            class="name"
            :class="{ scratched: market.scratched }"
          >
            {{ market.name }}
          </div>

          <div class="data">
            <span class="market-data-jockey">{{ market.jockey }}</span>
            <span v-if="!market.scratched && market.jockey && market.trainer">|</span>
            <span class="market-data-trainer">{{ market.trainer }}</span>
          </div>
        </td>

        <td class="name-spacer" />

        <td
          class="price"
          :style="currentPrice"
        >
          <span
            v-if="market.price"
            :class="{ 'odds-on-price': market.oddsOn }"
          >{{ displayPrice }}</span>
          <span v-if="!market.price && !market.scratched">SP</span>
        </td>

        <td
          class="prev"
          :style="previousPrice"
        >
          <span v-if="market.previousPrice">{{ previousDisplayPrice }}</span>
          <span v-if="!market.previousPrice && !market.scratched">SP</span>
        </td>

        <td
          class="place"
          :style="placePrice"
        >
          {{ placeDisplayPrice }}
        </td>
      </tr>
    </table>
    <div class="clearfix" />
  </div>
</template>

<script>
export default {
  name: 'Market',
  props: ['scrollMarkets', 'placesPaid', 'placePercentage', 'venueId', 'raceId', 'marketId', 'venueIndex', 'isMulti', 'quadrant'],
  data() {
    return {
      indexedMarketId: '',
      mCount: 0,
      scrollMarketIndex: 0
    };
  },
  computed: {
    marketStyle() {
      return this.$store.getters.marketStyle;
    },
    silkImageUrl() {
      if (this.market.silks) {
        return unescape(this.market.silks);
      }

      return null;
    },
    placePricePercentage() {
      if (this.market.price) {
        return +(this.market.price * (this.placePercentage / 100)).toFixed(3);
      }

      return '0';
    },
    marketDetails() {
      return this.$store.getters.marketDetails;
    },
    currentPrice() {
      return this.$store.getters.currentPrice;
    },
    previousPrice() {
      return this.$store.getters.previousPrice;
    },
    placePrice() {
      return this.$store.getters.placePrice;
    },
    market() {
      let venue = null;

      if (this.isMulti) {
        const quadVenues = this.$store.state.screenData.filter(item => item.quadrant === this.quadrant);

        venue = quadVenues[this.venueIndex];
      } else {
        venue = this.$store.state.screenData[this.venueIndex - 1];
      }

      if (venue && 'races' in venue) {
        const race = venue.races.find(item => item.raceId === this.raceId);

        if (race && race.markets) {
          const market = race.markets.find(item => item.marketId === this.indexedMarketId);

          if (market) {
            return market;
          }
        }
      }

      return {};
    },
    displayPrice() {
      const price = this.market.price;
      const fraction = this.$store.state.fractionTable.find(fraction => price >= fraction.priceFrom && price <= fraction.priceTo);

      return fraction && this.$store.state.screenConfig.priceDisplay === 'fraction'
        ? fraction.numerator + '/' + fraction.denominator
        : price;
    },
    previousDisplayPrice() {
      let fraction = this.$store.state.fractionTable.find(fraction =>
        this.market.previousPrice >= fraction.priceFrom && this.market.previousPrice <= fraction.priceTo
      );

      return fraction && this.$store.state.screenConfig.previousPriceDisplay === 'fraction'
        ? fraction.numerator + '/' + fraction.denominator
        : this.market.previousPrice;
    },
    placeDisplayPrice() {
      let fraction = this.$store.state.fractionTable.find(fraction =>
        this.placePricePercentage >= fraction.priceFrom && this.placePricePercentage <= fraction.priceTo
      );

      return fraction && this.$store.state.screenConfig.placePriceDisplay === 'fraction'
        ? fraction.numerator + '/' + fraction.denominator
        : this.placePricePercentage;
    }
  },
  watch: {
    marketId(newMarketId) {
      this.indexedMarketId = newMarketId;
    },
    raceId() {
      this.scrollMarketIndex = 0;

      if (this.scrollMarkets && this.scrollMarkets.length){
        this.indexedMarketId = this.scrollMarkets[this.scrollMarketIndex].marketId;
      }
    }
  },
  created() {
    this.indexedMarketId = this.marketId;

    if (this.scrollMarkets && this.scrollMarkets.length) {
      this.indexedMarketId = this.scrollMarkets[0].marketId;
      this.startScrollingMarkets(0);
    }
  },
  methods: {
    startScrollingMarkets() {
      setTimeout(() => {
        this.indexedMarketId = this.scrollMarkets[this.scrollMarketIndex].marketId;
        this.scrollMarketIndex++;

        if (this.scrollMarketIndex >= this.scrollMarkets.length) {
          this.scrollMarketIndex = 0;
        }

        this.startScrollingMarkets();
      }, this.$store.state.screenConfig.marketScrollInterval * 1000);
    }
  }
};
</script>

<style scoped>
.market {
    table-layout:fixed;
    width: 100%;
    border-spacing: 0;
    border-collapse: collapse;
}
.market-row {
    border-bottom: 1px solid #000;
    height: 60px;
}
.silk {
    width: 50px;
    padding-left: 10px;
}

.number {
    font-size: 40px;
    width: 60px;
    padding-left: 10px;
    text-align: center;
}

.runner {
    overflow:hidden;
    white-space:nowrap;
    padding-left:10px;
}

.name {
    font-size: 28px;
    font-weight: bold;
    padding-top: 2px;
    height: 30px;
    line-height: 30px;
}

.data {
    font-size: 15px;
    line-height: 25px;
    font-style: italic;
}

.market-data-jockey {
    margin-right: 10px;
}

.market-data-trainer {
    margin-left: 10px;
}
.name-spacer{
    width: 10px;
}
.price {
    font-size: 40px;
    font-weight: bold;
    text-align: center;
    width: 105px;
}
.odds-on-price {
    color: red;
}

.prev {
    font-size: 28px;
    padding-top: 4px;
    text-align: center;
    width: 70px;
}

.place {
    font-size: 20px;
    padding-top: 7px;
    text-align: center;
    width: 70px;
}

.scratched {
    text-decoration: line-through;
}
</style>



// WEBPACK FOOTER //
// Market.vue?d3baa928